export default "__VITE_ASSET__b680e8d1__"